import React, { useContext, useEffect } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { ThemeProvider } from '@material-ui/core';
import { Error } from './pages';
import { getRoutes } from './routes.js';
import { THDTheme } from './theme';
import './styles/app.scss';
export var App = function (_a) {
    var customerType = _a.customerType, customerRole = _a.customerRole;
    var instance = useContext(AppContext).instance;
    var _b = instance.router, currentRouteName = _b.currentRouteName, currentRouteComponent = _b.currentRouteComponent;
    var routes = getRoutes(currentRouteName, currentRouteComponent);
    var isB2B = customerType.toUpperCase() === 'B2B';
    useEffect(function () {
        document.title = 'The Home Depot';
    }, []);
    return (React.createElement(ThemeProvider, { theme: THDTheme },
        React.createElement(ScrollToTop, null),
        React.createElement(Routes, null,
            React.createElement(Route, { path: routes.perks.path, element: React.createElement(routes.perks.component, { customerType: customerType, customerRole: customerRole }) }),
            React.createElement(Route, { path: routes.rewardsHub.path, element: React.createElement(routes.rewardsHub.component, { customerType: customerType, customerRole: customerRole }) }),
            React.createElement(Route, { path: routes.pricingBenefits.path, element: React.createElement(routes.pricingBenefits.component, { customerType: customerType, customerRole: customerRole }) }),
            React.createElement(Route, { path: "/error", element: React.createElement(Error, null) }),
            React.createElement(Route, { element: React.createElement(Error, null) }))));
};
